import React from 'react';
import { observer, inject } from 'mobx-react';
import {AvFeedback, AvForm, AvInput} from 'availity-mobx-reactstrap-validation';

import Backdrop from 'js/components/core/Backdrop';
import ContinueButton, { buttonHeight } from 'js/components/core/SteppedPage/ContinueButton';

import AppContent from "js/components/AppContent";
import NameEntry from "js/components/pages/BuyerSignupPage/FullName/NameEntry";
import Title from "js/components/pages/BuyerSignupPage/FullName/NameEntry/Title";
import userCountry from "js/services/UserCountry";
import AvGroup from "js/components/pages/BuyerSignupPage/FullName/NameEntry/FullNameInput/AvGroup";

export default inject('page')(
  observer(({ page }) => {
    const buttonOffset = buttonHeight / 2;
    const contentOffset = !page.hasEnteredFullName ? `${buttonOffset + 1.5}rem` : `${buttonOffset}rem`;
    const step1Img = '/images/v2/sellers/rectangle-horizontal.png';
    const step2Img = '/images/v2/sellers/rectangle-horizontal-grey.png';
    const step3Img = '/images/v2/sellers/rectangle-horizontal-grey.png';

    return (
      <>
        <AppContent className="seller-items-page tw-bg-white" padded>
          <Backdrop offset={contentOffset}>
            <div className="pod-container" style={{padding: "0 1.5rem"}}>
              <div className="tw-flex tw-flex-wrap justify-content-between tw-w-full tw-gap-4 tw-mt-4 tw-mb-3">
                <div className="tw-lg-w-1/2 tw-flex-start tw-flex-auto">
                  <div className="tw-flex tw-mb-8">
                    <span>
                        <div className="tw-flex tw-gap-2 justify-content-between">
                        <span>
                          <img
                            src={`${step1Img}`}
                            alt="step 1"
                            style={{height:'4px', width:'90%'}}
                            className="tw-h-[4px] tw-w-[90%]"
                          />
                        </span>
                        <span>
                        <img
                          src={`${step2Img}`}
                          alt="step 2"
                          style={{height:'4px', width:'90%'}}
                          className="md:tw-hidden tw-h-[4px] md:tw-w-[155.67px] tw-w-[90%]"
                        />
                        <img
                          src={`${step2Img}`}
                          alt="step 2"
                          style={{height:'4px', width:'155.67px'}}
                          className="tw-hidden md:tw-block tw-h-[4px] md:tw-w-[155.67px] tw-w-[90%]"
                        />
                        </span>
                        <span>
                        <img
                          src={`${step3Img}`}
                          alt="step 3"
                          style={{height:'4px', width:'90%'}}
                          className="md:tw-hidden tw-h-[4px] md:tw-w-[155.67px] tw-w-[90%]"
                        />
                        <img
                          src={`${step3Img}`}
                          alt="step 3"
                          style={{height:'4px', width:'155.67px'}}
                          className="tw-hidden md:tw-block tw-h-[4px] md:tw-w-[155.67px] tw-w-[90%]"
                        />
                        </span>
                        </div>
                      </span>
                  </div>

                  <span className="flex-start" style={{font:'inter', fontWeight:'700', fontSize:'17px', lineHeight:'27px'}}>Let's get to know you</span>
                  <div className="md:tw-pr-20 tw-mt-8">
                    <AvForm onValidSubmit={page.nextDetail}>
                      <NameEntry animate={!page.full_name.length} />
                      <ContinueButton flat onClick={page.nextStep} disabled={!page.full_name.length} />
                    </AvForm>
                  </div>
                </div>
                <div className="tw-lg-w-1/2 tw-flex-auto">
                  <div style={{height:'100%'}} className="tw-hidden md:tw-block tw-w-full tw-h-full">
                    <img
                      src="/images/v2/buyers/shop-with-confidence1.png"
                      alt="Shop with confidence"
                      style={{height:'742px', width:'585px'}}
                      className="tw-h-[742px] tw-w-[585px]"
                    />
                  </div>
                  <div style={{height:'100%'}} className="tw-block md:tw-hidden tw-w-full tw-h-full">
                    <img
                      src="/images/v2/buyers/shop-with-confidence2.png"
                      alt="Shop with confidence"
                      style={{height:'517px'}}
                      className="tw-h-[517px] tw-w-full"
                    />
                  </div>
                </div>
              </div>
            </div>
          </Backdrop>
        </AppContent>



      </>
    );
  }),
);

